var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1BunchOfKeys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 25.77V54H38V27h4v23h21V26a10.48 10.48 0 00-16.26-9H41a14.45 14.45 0 0111.5-5.73A14.23 14.23 0 0166.93 24l.07 1.77zM45 47h15v-3H45v3zm0-9v3h8v-3h-8zM33.15 23c.266 1.022.4 2.074.4 3.13A12.859 12.859 0 0127 37.34v12.24l-3.23 4 3 3.85-3 3.84 3.09 4H27v.37l-5.62 6.16L16 65.64V38.11a12.862 12.862 0 01-4.937-20.485A12.86 12.86 0 0132 20h16.07a4 4 0 110 3H33.15zM19 21.5a1.5 1.5 0 011.5-1.5h3.89a4 4 0 100 3H20.5a1.5 1.5 0 01-1.5-1.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Bunch_of_keys.21a4612b.svg";
export { SvgG1BunchOfKeys as ReactComponent };